import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const onboarding_feature_new_full_kpi = {
	id: "onboarding_feature_new_full_kpi",
	name: "KPI Onboarding Funkcje aktywowane po nazwie, osobie i lokalizacji",
	data: [
		{
			id: "FEATURE_FIRST_USAGE",
			resource: "ORGANIZATION_FEATURE_USAGE",
			filter: "feature_sold_by_partner_type|e=CSVçusage_month_index|e=1çusage_type|e=MONTHLY",
			groups: ["NONE", "FEATURE_SOLD_BY_PARTNER", "ORGANIZATION_NAME", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "date_year_month|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "DATE_MONTH",
					filter: "date_year_month|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "products_progress",
			name: "KPI Onboarding Funkcje aktywowane po nazwie, osobie i lokalizacji",
			rows: [
				{
					id: "FEATURE_FIRST_USAGE",
					name: "Funkcje",
					data_id: "FEATURE_FIRST_USAGE",
					group: "NAME",
					aggregate: "usage_count",
					aggregate_columns: {
						usage_count: "usage_count",
						usage_count_monthly: "usage_count",
						usage_count_current: "last_usage_count",
						usage_value_current: "last_usage_value",
					},
				},
			],
			columns: [
				{
					id: "usage_count",
					data_column_id: "summary",
					name: "Użycia",
				},
				{
					id: "usage_count_monthly",
					data_column_id: "monthly",
					name: "Użycia",
					values_dynamic: "values_previous_3_months",
				},
				{
					id: "usage_count_current",
					data_column_id: "summary",
					name: "Ilość używanych",
				},
				{
					id: "usage_value_current",
					data_column_id: "summary",
					name: "Zużycie (30 dni)",
				},
			],
		},
	],
} as ConfigReportComboApi;
